import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { assignDefinedFields } from '@polyai/stream/store/utils/assign-fields';
import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

import {
  createTestCase,
  deleteTestCase,
  setTestCaseAssertions,
  setTestCaseFunctionCalls,
  setTestCaseTags,
  updateTestCase,
} from '../actions';
import type { TestCase } from '../types';

export const testCaseAdapter = createEntityAdapter<TestCase>();
export const testCaseSelectors = testCaseAdapter.getSelectors();

const initialState = testCaseAdapter.getInitialState();

const slice = createSlice({
  name: 'testing/testCases',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(createTestCase, (state, action) => {
      const testCase: TestCase = {
        ...action.payload,
        assertions: [],
        functionCalls: [],
        tags: [],
        createdBy: '',
        createdAt: '',
        updatedAt: '',
        updatedBy: '',
      };
      assignMetadata(action, testCase);
      testCaseAdapter.addOne(state, testCase);
    });

    builder.addCase(updateTestCase, (state, action) => {
      const existing = state.entities[action.payload.id];

      if (existing) {
        assignDefinedFields(existing, action.payload);
        assignMetadata(action, existing);
      }
    });

    builder.addCase(setTestCaseAssertions, (state, action) => {
      const existing = state.entities[action.payload.id];

      if (existing) {
        existing.assertions = action.payload.assertions;
        assignMetadata(action, existing);
      }
    });

    builder.addCase(setTestCaseFunctionCalls, (state, action) => {
      const existing = state.entities[action.payload.id];

      if (existing) {
        existing.functionCalls = action.payload.functionCalls;
        assignMetadata(action, existing);
      }
    });

    builder.addCase(setTestCaseTags, (state, action) => {
      const existing = state.entities[action.payload.id];

      if (existing) {
        existing.tags = action.payload.tags;
        assignMetadata(action, existing);
      }
    });

    builder.addCase(deleteTestCase, (state, action) => {
      const existing = testCaseSelectors.selectById(state, action.payload.id);
      if (existing) {
        testCaseAdapter.removeOne(state, action.payload.id);
      }
    });
  },
});

export default slice.reducer;
